import { render, staticRenderFns } from "./ImportXLS.vue?vue&type=template&id=ceb5046c&scoped=true&"
import script from "./ImportXLS.vue?vue&type=script&lang=js&"
export * from "./ImportXLS.vue?vue&type=script&lang=js&"
import style0 from "./ImportXLS.vue?vue&type=style&index=0&id=ceb5046c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb5046c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
